document.addEventListener('DOMContentLoaded', function() {
  var bar    = document.querySelector('product-sticky-bar-mobile');
  var footer = document.querySelector('footer');
  if (!bar || !footer) return;

  // IntersectionObserver で footer の表示/非表示を監視
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        // フッターがビューポートに入ったらバーをフェードアウト
        bar.classList.add('hidden');
      } else {
        // フッターから離れたらバーをフェードイン
        bar.classList.remove('hidden');
      }
    });
  }, {
    root: null,       // ビューポートをルートに
    threshold: 0      // フッターのどこかが見えた瞬間に反応
  });

  observer.observe(footer);
});

//商品レビューのmeta高さ調整
document.addEventListener('DOMContentLoaded', function () {
  const mq = window.matchMedia('(min-width: 700px)');
  if (!mq.matches) return; // 700px未満なら何もしない

  const items = document.querySelectorAll('.blog-post-list .pr__meta');
  const itemsArray = Array.from(items);

  for (let i = 0; i < itemsArray.length; i += 2) {
    const item1 = itemsArray[i];
    const item2 = itemsArray[i + 1];

    if (!item2) continue;

    const h1 = item1.offsetHeight;
    const h2 = item2.offsetHeight;
    const maxHeight = Math.max(h1, h2);

    item1.style.height = maxHeight + 'px';
    item2.style.height = maxHeight + 'px';
  }
});
